import React from 'react';
export const Header = () => {
  return <header className="w-full bg-amber-50 shadow-sm py-3" data-id="element-147">
      <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-148">
        <div data-id="element-149">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a9uJaJmjsRVQhXzjk9PwNU/443d90b6-353e-4bcf-b252-c01302765c2c.png" alt="Snouty & Co. Logo" className="h-16" data-id="element-150" />
        </div>
        
      </div>
    </header>;
};